import AuthenticateEmailScreen from "Containers/AuthenticateEmailScreen/index";
import CreateProjectContainer from "Containers/CreateProjectContainer";
import ExploreScreen from "Containers/ExploreContainer";
import ExploreDetailScreen from "Containers/ExploreDetailContainer";
import ForgottenPasswordScreen from "Containers/ForgottenPasswordScreen";
import HomeScreen from "Containers/HomeScreen";
import LoadingScreen from "Containers/LoadingScreen";
import LoginScreen from "Containers/LoginScreen";
import NavbarScreen from "Containers/NavbarScreen";
import PageNotFoundContainer from "Containers/PageNotFoundContainer";
import PasswordResetScreen from "Containers/PasswordResetScreen";
import ProfileScreen from "Containers/ProfileScreen";
import RegisterScreen from "Containers/RegisterScreen";
import navRoutes from "Navigation/NavRoutes";
import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AuthenticationActions, {
  AuthenticationSelectors
} from "Redux/AuthenticationRedux";
import ProfileActions from "Redux/ProfileRedux";
import RestrictedRoute from "./RestrictedRoute";
import UpdateDetailContainer from "Containers/UpdateDetailContainer";
import UpdateFeedContainer from "Containers/UpdateFeedContainer";
import ContactUs from "Containers/ContactUsContainer";
import Footer from "Containers/Footer";
import PostUpdateContainer from "Containers/PostUpdateContainer";

class MainRoute extends Component {
  state = {
    preventAccess: true,
    notification_sockets: {}
  };

  async componentDidMount() {
    if (this.props.isAuthenticated) {
      // If the user is authenticated, this is the first thing we do
      await this.props.getUserDetails();
      await this.props.getProfile(); // Is this needed?
    }
  }

  render() {
    const { isAuthenticated } = this.props;
    return (
      <div className={"App-container"}>
      <Router>
        <Route path="/" component={NavbarScreen} />
        {/* <Route path="/" render={() => <MainBackground />} /> */}
        <div className={"App-content"}>
        <Switch>
          <Route exact path="/" component={HomeScreen} />
          <Route exact path={navRoutes.explore} component={ExploreScreen} />
          <Route exact path={navRoutes.updateFeed} component={UpdateFeedContainer} />
          <Route path={navRoutes.signup} component={RegisterScreen} />
          <Route path={navRoutes.login} component={LoginScreen} />

          <Route path={navRoutes.home} component={HomeScreen} />
          <Route
            exact
            path={navRoutes.createProject}
            component={CreateProjectContainer}
          />
          <Route path={navRoutes.postUpdate} component={PostUpdateContainer} />
          <Route
            path={navRoutes.forgottenPassword}
            component={ForgottenPasswordScreen}
          />
          <Route path="/PasswordReset" component={PasswordResetScreen} />
          <Route
            path="/AuthenticateEmail"
            component={AuthenticateEmailScreen}
          />
          <Route
            path={`${navRoutes.explore}/:slug`}
            component={ExploreDetailScreen}
          />
          <Route
            path={`${navRoutes.updateFeed}/:project_id/:update_id`}
            component={UpdateDetailContainer}
          />
          <Route path={`${navRoutes.profile}/:id`} component={ProfileScreen} />
          <Route path="/Loading" component={LoadingScreen} />
          <Route path={navRoutes.contactUs} component={ContactUs} />
          <RestrictedRoute isAuthenticated={isAuthenticated} />
          <Route component={PageNotFoundContainer} />
        </Switch>
        </div>
        <Route path={navRoutes.footer} component={Footer} />
      </Router>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: AuthenticationSelectors.getAuthenticated(state),
    authUsername: AuthenticationSelectors.getUsername(state),
    userDetails: AuthenticationSelectors.getUserDetails(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getUserDetails: () =>
      dispatch(AuthenticationActions.getUserDetailsRequest()),
    getProfile: () =>
      dispatch(ProfileActions.profileRequest()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainRoute);
